var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback, } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { position, space, fontSize, display, flexDirection, justifyContent, alignItems, width, height, backgroundSize, backgroundPosition, backgroundRepeat, boxShadow, order, themeGet, } from 'styled-system';
import { breakpoint } from '../../common/theme/helper';
import { Grid } from '../../common/components/Grid';
import { ResponsiveLazyImage, } from '../../common/components/LazyImage';
import { CenterRightControls, CenterLeftControls, } from '../../common/components/LazyCarouselControls';
import LazyCarousel from '../../common/components/LazyCarousel';
import { Button } from '../../common/components/Button';
import { Stoerer } from '../../common/components/Stoerer';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import LegalNotesLink from './LegalNotesLink';
import CampaignInfo, { EllipsisParagraph } from './CampaignInfo';
import { getPageAppTrackerProps, } from '../../common/tracking/getTrackerProps';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
import { ThemedMedia } from '../../common/components/Media';
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "Primary";
    ButtonType["Secondary"] = "Secondary";
})(ButtonType || (ButtonType = {}));
var HomepageTopTeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
HomepageTopTeaserGrid.defaultProps = {
    px: 0,
    pb: ['40px', 6, null, '56px'],
};
var SlideContainer = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  text-decoration: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  text-decoration: none;\n"])), display, flexDirection, height, boxShadow, width, function (_a) {
    var bg = _a.bg;
    return (bg ? bg : themeGet('colors.gray.12'));
});
SlideContainer.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    height: [368, 220, 304, 394],
    width: 1,
};
var InformationBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n"], ["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ",
    ";\n"])), display, flexDirection, justifyContent, alignItems, order, width, height, space, function (props) {
    return props.informationBoxColor
        ? props.informationBoxColor
        : themeGet('colors.gray.10');
});
InformationBox.defaultProps = {
    width: [1, '70%', null, '80%'],
    height: ['200px', 'auto'],
    pl: [0, '40px', 6, 7],
    pr: [0, 'sp_16'],
    py: [3, null, '28px', '66px'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['flex-start', 'space-between'],
    alignItems: ['center', 'normal'],
    order: [2, 1],
};
var Title = styled(EllipsisParagraph)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  margin-bottom: ", "px;\n\n  ", " {\n    margin-bottom: 0;\n  }\n"], ["\n  ", ";\n  margin-bottom: ", "px;\n\n  ", " {\n    margin-bottom: 0;\n  }\n"])), order, function (props) { return (props.withSubtitle ? 0 : 32); }, breakpoint(0));
Title.defaultProps = __assign(__assign({}, EllipsisParagraph.defaultProps), { as: 'h2', mx: 0, fontSize: ['22px', null, '30px', 8], lineHeight: [4, null, 5, 6], order: [1, 2] });
var Subtitle = styled(EllipsisParagraph)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), order, fontSize, space);
Subtitle.defaultProps = __assign(__assign({}, EllipsisParagraph.defaultProps), { as: 'p', fontSize: [4, null, 5, '22px'], mt: [1, null, 2, 3], order: [2, 3] });
var StyledButton = styled(Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  /* The !important is because of Shop-Reboot :'( */\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  /* The !important is because of Shop-Reboot :'( */\n  ",
    ";\n"])), order, space, width, fontSize, justifyContent, boxShadow, themeGet('colors.orange.50'), function (props) {
    return props.kind === 'secondary' && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", " !important;\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover {\n        color: ", " !important;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "], ["\n      color: ", " !important;\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover {\n        color: ", " !important;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "])), themeGet('colors.gray.10')(props), themeGet('colors.white')(props), themeGet('colors.gray.9')(props), themeGet('colors.orange.50')(props), themeGet('colors.white')(props), themeGet('colors.orange.50')(props));
});
StyledButton.defaultProps = __assign(__assign({}, Button.defaultProps), { as: 'button', width: '160px', px: 0, py: 2, mt: [1, null, '10px', '18px'], fontSize: 4, justifyContent: 'center', boxShadow: 'none', order: 4 });
var RightSideWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), position, width, height, order);
RightSideWrapper.defaultProps = {
    position: 'relative',
    width: 1,
    order: [1, 2],
};
var ImageContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, height);
ImageContainer.defaultProps = {
    height: [168, 220, 304, 394],
};
var Image = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"])), width, height, backgroundRepeat, backgroundPosition, backgroundSize, function (_a) {
    var image = _a.image;
    return "url(" + image + ")";
}, function (_a) {
    var show = _a.show;
    return "" + Number(show);
});
Image.defaultProps = {
    width: 1,
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
};
var CarouselContainer = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: inherit;\n  ", ";\n"], ["\n  width: inherit;\n  ", ";\n"])), boxShadow);
CarouselContainer.defaultProps = {
    boxShadow: ['0 2px 6px 0 #c0c0c0', 'none'],
};
var HomepageTopTeaser = function (_a) {
    var items = _a.items;
    var _b = __read(useState(0), 2), activeSlide = _b[0], setActiveSlide = _b[1];
    useEffect(function () {
        var activeTopTeaserPromotion = {
            name: items[activeSlide].tracking.name,
            placement: items[activeSlide].tracking.placement,
            position: activeSlide,
        };
        dispatchTrackingEvent({
            event: 'promoView',
            eventAction: 'view',
            eventCategory: 'promotion',
            eventData: {
                promotions: [activeTopTeaserPromotion],
            },
        });
    }, [activeSlide, items]);
    var onClickLegalNotes = function (_a) {
        var emit = _a.emit, html = _a.html;
        return function (event) {
            event.preventDefault();
            emit({ html: html, open: true });
        };
    };
    var handleAfterSlide = useCallback(function (currentSlide) {
        setActiveSlide(currentSlide);
    }, [activeSlide]);
    var hasMultipleSlides = items.length > 1;
    var arrowProps = {
        display: 'flex',
        justifyContent: 'center',
        arrowSize: '14px',
        controlShadow: 'none',
        size: '28px',
        mx: 2,
    };
    return (React.createElement(ThemedMedia, null, function (_a) {
        var tablet = _a.tablet, desktop = _a.desktop;
        return (React.createElement(HomepageTopTeaserGrid, null,
            React.createElement(CarouselContainer, null,
                React.createElement(LazyCarousel, { showControlsOnHover: desktop, renderCenterLeftControls: function (props) { return (React.createElement(CenterLeftControls, __assign({}, arrowProps, props))); }, renderCenterRightControls: function (props) { return (React.createElement(CenterRightControls, __assign({}, arrowProps, props))); }, wrapAround: hasMultipleSlides, overflowHidden: true, afterSlide: handleAfterSlide }, items.map(function (_a, index) {
                    var stoerer = _a.stoerer, imageProps = _a.image, campaignDuration = _a.campaignDuration, countDown = _a.countDown, title = _a.title, subtitle = _a.subtitle, cta = _a.cta, informationBoxBg = _a.informationBoxBg, informationBoxColor = _a.informationBoxColor, legalDisclaimer = _a.legalDisclaimer, _b = _a.tracking, _c = _b === void 0 ? {} : _b, name = _c.name, placement = _c.placement;
                    return (React.createElement(SlideContainer, __assign({ key: "slide-" + index, bg: informationBoxBg }, getPageAppTrackerProps(__assign(__assign({}, (index === 0 && {
                        'data-prefetch': true,
                    })), { 'data-testid': "homepage-top-teaser-slide-" + index, type: cta.type, href: cta.href }), {
                        event: 'promoClick',
                        eventData: {
                            promotions: [
                                {
                                    name: name,
                                    placement: placement,
                                    position: index,
                                },
                            ],
                        },
                    })),
                        React.createElement(InformationBox, { informationBoxColor: informationBoxColor, "data-testid": "information-box-slide" },
                            React.createElement(CampaignInfo, { duration: campaignDuration, countDown: countDown }),
                            title && (React.createElement(Title, { withSubtitle: Boolean(subtitle), "data-testid": "title" }, title)),
                            subtitle && (React.createElement(Subtitle, { "data-testid": "subtitle" }, subtitle)),
                            React.createElement(StyledButton, { "data-testid": "button", kind: cta.type === ButtonType.Secondary
                                    ? 'secondary'
                                    : 'primary' }, cta.label)),
                        React.createElement(RightSideWrapper, { "data-testid": "right-side-slide" },
                            React.createElement(ImageContainer, { "data-testid": "image-container-slide" },
                                stoerer && (React.createElement(Stoerer, { label: stoerer.label, borderColor: stoerer.borderColor, themeTop: [0, 3, '28px', '66px'] })),
                                React.createElement(ResponsiveLazyImage, __assign({}, imageProps), function (_a) {
                                    var image = _a.image, thumbnail = _a.thumbnail, loaded = _a.loaded, intersected = _a.intersected, innerRef = _a.innerRef;
                                    return (React.createElement(Image, { "data-testid": "image", ref: innerRef, alt: imageProps.alt, show: intersected, image: loaded ? image : thumbnail }));
                                })),
                            legalDisclaimer && (React.createElement(DisclaimerSubscription, null, function (_a) {
                                var value = _a.value, emit = _a.emit;
                                var linkLabel = legalDisclaimer.linkLabel, linkLabelColor = legalDisclaimer.linkLabelColor, contentHtml = legalDisclaimer.contentHtml;
                                return (React.createElement(LegalNotesLink, { alignBottom: tablet, linkLabel: linkLabel, linkLabelColor: linkLabelColor, onClick: onClickLegalNotes({
                                        emit: emit,
                                        html: contentHtml,
                                    }) }));
                            })))));
                })))));
    }));
};
export default HomepageTopTeaser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
